import Blank from "./Blank";
import {DisplayConfig} from "../Config";

import './Video.css'

export default function Video({config, alternatePresentingSponsor } : {
    config: DisplayConfig,
    alternatePresentingSponsor?: string
}) {
    if(!config.overlay) {
        return <Blank config={config} />
    }

    let style = { background: config.overlayColor };

    return <div className={"h-100 w-100 blankPage"} style={style}/>;
}